"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _firestorePlus = require("firestore-plus");

var yup = _interopRequireWildcard(require("yup"));

var types = _interopRequireWildcard(require("../types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

class RentalSchema extends _firestorePlus.Schema {
  static postValidate(data) {
    console.log("[RentalSchema#postValidate]", data);
  }

}

exports.default = RentalSchema;
RentalSchema.fieldTypes = {
  // Rental Data
  createdAt: types.DateTime,
  approved: yup.bool(),
  isValid: yup.bool(),
  cancelled: yup.bool(),
  // With two l's because we're british(?)
  start_date: types.DateTime,
  end_date: types.DateTime,
  num_days: yup.number(),
  service_fee: yup.number(),
  total_price: yup.number(),
  total_price_nofee: yup.number(),
  price_d: yup.number(),
  price: yup.mixed(),
  // TODO
  payment_state: yup.mixed().oneOf(['FAIL', 'PAID', 'UNPAID']),
  payment_date: types.DateTime,
  decision_date: types.DateTime,
  // Item Data
  item: types.Firestore.DocumentReference,
  item_img: yup.string(),
  item_name: yup.string(),
  item_price: yup.number(),
  // Exchange Data
  lender: types.Firestore.DocumentReference,
  lender_name: yup.string(),
  renter: types.Firestore.DocumentReference,
  renter_name: yup.string(),
  stripe_dest_account: yup.string(),
  stripe_customer_id: yup.string(),
  stripe_source: yup.mixed()
};
//# sourceMappingURL=Rental.js.map